<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_4"></a>Introduction and Compilation Copyright © 2016 by The Omidi Company LLC</p>
<p><em>Cats on Instagram</em> and @cats_of_instagram are operated independently and are not affiliated with, endorsed, or sponsored by Instagram LLC. All photographs copyright © by the individual photographers.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN 978-1-4521-5196-0 (hc)</p>
<p>ISBN 987-1-4521-5281-3 (epub, mobi)</p>
<p>Design by Hillary Caudle</p>
<p>Front jacket photographs by: @juiceecat, @alain_cat, @polagram, @precious_luna, @wednesdayandgizmo, @threescaredycats, @whiskered_away, @cheddarcheesepuff, @jesyalmaguer, @panchobear, @momomilochub, @henrynoodle, @s_nookie, @mspollypockets, @veronicagrojano, @meowscott, @musammmmm</p>
<p>Back jacket photographs by: @themaestros, @summer_dawn_ adams, @macchacat, @bagwellphotography, @playground_ ragdolls, @exoticniko, @yeonhoo_doma, @anniepaddington, @chippydiego, @molla_and_bozley, @nala_cat</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, CA 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank"><span class="gray">www.chroniclebooks.com</span></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05copyright.vue?2fba0494